<template>
  <v-dialog
    v-model="localShow"
    max-width="600"
    @update:model-value="handleDialogUpdate"
  >
    <v-card>
      <v-toolbar density="compact">
        <v-toolbar-title
          ><v-icon v-if="icon" size="small" start>{{ icon }}</v-icon>
          {{ title }}</v-toolbar-title
        >
      </v-toolbar>

      <v-card-text>
        <slot name="default">
          {{ message }}
          <v-alert
            v-if="warnText"
            class="mt-4 text-body-medium"
            variant="tonal"
            color="warning"
          >
            {{ warnText }}
          </v-alert>
        </slot>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          :color="cancelColor"
          :disabled="loading"
          variant="text"
          @click="handleCancel"
        >
          {{ cancelText }}
        </v-btn>
        <v-btn
          :color="color"
          :disabled="confirmDisabled"
          :loading="loading"
          prepend-icon="mdi-check"
          variant="elevated"
          @click="handleConfirm"
        >
          {{ confirmText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
  import { computed } from 'vue'

  const props = defineProps({
    cancelColor: {
      default: '',
      type: String,
    },
    cancelText: {
      default: 'Cancel',
      type: String,
    },
    color: {
      default: 'primary',
      type: String,
    },
    confirmDisabled: {
      default: false,
      type: Boolean,
    },
    confirmText: {
      default: 'Confirm',
      type: String,
    },
    icon: {
      default: null,
      type: String,
    },
    loading: {
      default: false,
      type: Boolean,
    },
    message: {
      required: true,
      type: String,
    },
    show: {
      default: false,
      type: Boolean,
    },
    title: {
      default: 'Confirm Action',
      type: String,
    },
    warnText: {
      default: '',
      type: String,
    },
  })

  const emit = defineEmits(['update:show', 'confirm', 'cancel'])

  const localShow = computed({
    get: () => props.show,
    set: (value) => emit('update:show', value),
  })

  function handleCancel() {
    emit('cancel')
    localShow.value = false
  }

  function handleConfirm() {
    emit('confirm')
  }

  function handleDialogUpdate(value) {
    if (!value) {
      emit('cancel')
    }
  }
</script>
